import { render, staticRenderFns } from "./Mason.vue?vue&type=template&id=43e83b90&scoped=true&"
import script from "./Mason.vue?vue&type=script&lang=js&"
export * from "./Mason.vue?vue&type=script&lang=js&"
import style0 from "./Mason.vue?vue&type=style&index=0&id=43e83b90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e83b90",
  null
  
)

export default component.exports